import * as React from "react";
import styled from "styled-components";
/** Original floor-plan table artwork (served from dashboard static). */
export const TABLE_TEMPLATE_IMAGE_SRC = {
    square_2: "/images/floor-tables/square_2.png",
    square_4: "/images/floor-tables/square_4.png",
    rect_6: "/images/floor-tables/rect_6.png",
    rect_8: "/images/floor-tables/rect_8.png",
    circle_2: "/images/floor-tables/circle_2.png",
    circle_4: "/images/floor-tables/circle_4.png",
    circle_6: "/images/floor-tables/circle_6.png",
    circle_8: "/images/floor-tables/circle_8.png",
};
export const FLOOR_TABLE_DISPLAY_PX = 150;
const TableImg = styled.img `
	display: block;
	width: ${(p) => (p.$fill ? "100%" : `${p.$size}px`)};
	height: ${(p) => (p.$fill ? "100%" : `${p.$size}px`)};
	object-fit: contain;
	pointer-events: none;
	user-select: none;
	${(p) => p.$floor
    ? `
		mix-blend-mode: screen;
	`
    : `
		background: #0f172a;
		border-radius: 6px;
	`}
`;
export function TableTemplateGraphic({ templateId, size = 40, floorCanvas = false, fill = false, className, style, }) {
    const src = TABLE_TEMPLATE_IMAGE_SRC[templateId];
    const useFill = fill || (floorCanvas && size === undefined && !style?.width);
    const px = useFill ? undefined : size || (floorCanvas ? FLOOR_TABLE_DISPLAY_PX : 40);
    return (React.createElement(TableImg, { className: className, src: src, alt: "", "aria-hidden": true, draggable: false, "$size": px, "$fill": useFill, "$floor": floorCanvas, style: style }));
}
//# sourceMappingURL=table-template-graphic.js.map